"use strict";
/*
 * 8x8 Confidential & Proprietary || Copyright 2025 8x8, Inc. or its affiliates. All Rights Reserved.
 *  _____      _____
 * |  _  |    |  _  |
 *  \ V /__  __\ V /   ___ ___  _ __ ___
 *  / _ \\ \/ // _ \  / __/ _ \| '_ ` _ \
 * | |_| |>  <| |_| || (_| (_) | | | | | |
 * \_____/_/\_\_____(_)___\___/|_| |_| |_|
 *
 * @License https://www.8x8.com/terms-and-conditions/software-development-kit-license-agreement
 * @Author Comanici Paul
 * @Date 2025/05/14
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=system.js.map